import { createApiClient } from "@kourai/api/client";
import { useMemo } from "react";
import { API_URL } from "./api-url";
import { useSession } from "./auth-client";

export function useApi() {
  const { data: session } = useSession();
  const token = session?.session?.token as string | undefined;

  return useMemo(
    () => createApiClient(API_URL, token ? { Authorization: `Bearer ${token}` } : undefined),
    [token],
  );
}
